import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, videos, conselho_fiscal } from '../../../settings';
import { DelayLink, CardSliderFotos } from '../../../components';

import './ConselhoFiscal.scss';

class ConselhoFiscal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
    };

    this.conselho_fiscal = conselho_fiscal.pessoas;
    this.images = images;
    this.videos = videos;
    this.texts = texts;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  render() {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Governança Corporativa - {this.texts.title}</title>
        </Helmet>

        <div className="conselho-fiscal-home page-gradient page-gradient--blue bg-gray" ref="conselho-fiscal-home">
          <section className="conselho-fiscal-home-area governanca-header page-gradient__header">
            <div className="container">
              <div className="row">
                <div className="col-5">
                  <Fade bottom>
                    <div className="page-header">
                      <h1 className="page-header__title">Conselho Fiscal</h1>
                      <p className="page-header__description gri_text">
                        É formado por <strong>três representantes</strong> dos associados, que são eleitos junto com a Diretoria
                        pela Assembleia Geral. Eles devem examinar as contas e demonstrações financeiras da Associação,
                        além de contratar uma auditoria externa independente para dar um parecer sobre esse material.
                        Têm apenas uma reunião presencial no ano, mas podem ser convocados para encontros
                        extraordinários.
                      </p>
                    </div>
                  </Fade>
                </div>

                <div className="col-7 ">
                  <img src={this.images.conselho_fiscal.ilustra1} className="first-image" />
                  <img src={this.images.conselho_fiscal.ilustra1_1} className="second-image" />
                  <img src={this.images.conselho_fiscal.ilustra1_2} className="third-image" />
                  <svg viewBox="0 0 340 333" className="fourth-image">
                    <polyline
                      className="path"
                      fill="transparent"
                      stroke="#FCAF00"
                      stroke-width="4"
                      points="23,150 84,69 127,110 156,64 192,77 238,27 "
                    />
                  </svg>
                </div>
              </div>
            </div>
          </section>

          <section className="governanca-body governanca-body--card page--blue">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="governanca-body__content">
                    <Fade bottom>
                      <h2 className="center-title">Conheça o conselho:</h2>

                      <CardSliderFotos
                        items={this.conselho_fiscal}
                        url={this.images.conselho_fiscal.path_url}
                        color={'blue'}
                      />
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="conselho-fiscal-footer-area governanca-footer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--green box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-9 col--text">
                            <h4>Entenda como é formado o nosso Conselho de Ética</h4>
                            <DelayLink
                              to="/governanca-corporativa/conselho-de-etica"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                          <div className="col col-3 col--image">
                            <img
                              src={this.images.conselho_fiscal.pessoa1}
                              className="pessoa_destaque pessoa_destaque--1"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { ConselhoFiscal };
